module.exports = __webpack_public_path__ + "static/media/redis.741ae510.svg";